.content {
  width: 100%;
  flex: 1;
  min-height: 0;
}

.content-detalhada-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.toggle-container {
  padding: 8px 16px;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  background-color: var(--rs-gray-50, #f7f7fa);
  border-bottom: 1px solid var(--rs-gray-200, #e5e5ea);
}
.toggle-container label {
  font-size: 14px;
  color: var(--rs-text-primary, #575757);
  cursor: pointer;
}

.content-detalhada {
  overflow: auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  cursor: grab;
}

.smooth-scroll {
  scroll-behavior: smooth;
}

.timeline-detalhada {
  min-width: 6400px;
  width: 6400px !important;
}
.timeline-detalhada :global .timeline {
  overflow-x: visible !important;
  width: 6400px !important;
  min-width: 6400px !important;
}
.timeline-detalhada :global .body {
  min-width: 6400px !important;
  width: 6400px !important;
}
.timeline-detalhada :global .lines {
  min-width: 6400px !important;
  width: 6400px !important;
}
.timeline-detalhada :global .header {
  min-width: 6400px !important;
  width: 6400px !important;
}
.timeline-detalhada :global .hours {
  min-width: 6400px !important;
  width: 6400px !important;
}

.wrapper {
  width: 100%;
  height: 100%;
}

.h-100 {
  height: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */